import IsoToLatLong from 'country-iso-to-coordinates';
import prettyBytes from 'pretty-bytes';
import { lighten } from '@mui/material';
import { t } from '@ankr.com/common';

import { Country, CountriesMap } from '../types';
import { StatsTableProps } from '../components/StatsTable';

const COLORS = Array(10)
  .fill(0)
  .map((_, index) => lighten('#25272C', 0.1 * index));

const DARK_COLORS = [
  '#25272C',
  '#477AF3',
  '#5987F3',
  '#5987F3',
  '#6B94F4',
  '#9AA1B0',
  '#82899A',
  '#585E6B',
  '#535863',
  '#42464F',
];

export const getCountriesList = (
  countries: CountriesMap | undefined = {},
  isLightTheme: boolean,
  datatype: StatsTableProps['dataType'] = 'requests',
) =>
  Object.values(countries)
    .sort((a, b) => b.requests - a.requests)
    .slice(0, 10)
    .filter(item => IsoToLatLong[item.country])
    .map<Country>((item, index) => {
      const data = IsoToLatLong[item.country];

      const { coordinate, name } = data;

      const [lat, lon] = coordinate.map(Number);

      const value =
        datatype === 'requests'
          ? t('chain-item.map.stats-table.requests', {
              value: item.requests,
            })
          : prettyBytes(item.requests, { maximumFractionDigits: 2 });

      return {
        color: isLightTheme ? COLORS[index] : DARK_COLORS[index],
        coordinates: [lon, lat],
        isoA2: item.country,
        name,
        requests: value,
      };
    });
